class CartFreeShippingBar extends HTMLElement {
  connectedCallback() {
    const fill = this.querySelector('.cart-free-shipping__fill');
    if (!fill) return;

    const target = parseFloat(this.dataset.fsPercent || '0') || 0;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion) {
      fill.style.width = `${target}%`;
      window.cartFreeShippingPercent = target;
      return;
    }

    const previous =
      typeof window.cartFreeShippingPercent === 'number' ? window.cartFreeShippingPercent : 0;

    fill.style.transition = 'none';
    fill.style.width = `${previous}%`;
    // Force reflow so the starting width is committed before we transition.
    void fill.offsetWidth;
    fill.style.transition = 'width 0.5s ease';
    fill.style.width = `${target}%`;

    window.cartFreeShippingPercent = target;
  }
}

if (!customElements.get('cart-free-shipping-bar')) {
  customElements.define('cart-free-shipping-bar', CartFreeShippingBar);
}
